export const getIsIos = () => {
  // iPad on iOS 13 detection
  const isIos13 = navigator.userAgent.includes("Mac") && "ontouchend" in document; 

  return (
    ["iphone", "ipad", "ipod", "ipod touch"].includes(navigator.platform.toLowerCase()) || isIos13
  );
};
